/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homehelpcardtitle3Inputs */



/**
* | output |
* | --- |
* | "Help & feedback" |
*
* @param {Homehelpcardtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homehelpcardtitle3 = /** @type {((inputs?: Homehelpcardtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homehelpcardtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Help & feedback")
	return /** @type {LocalizedString} */ ("Hilfe & Feedback")
});
export { homehelpcardtitle3 as "homeHelpCardTitle" }